import type { TournamentType } from '@pokerroom/types';

export function formatDuration(seconds: number): string {
  const value = Math.max(0, Math.floor(seconds));
  return [Math.floor(value / 3600), Math.floor((value % 3600) / 60), value % 60]
    .map((part) => String(part).padStart(2, '0'))
    .join(':');
}

export function elapsedSeconds(
  startedAt: string | null | undefined,
  now: number,
  completedAt?: string | null,
): number {
  const start = Date.parse(startedAt ?? '');
  const end = completedAt ? Date.parse(completedAt) : now;
  return Number.isFinite(start) && Number.isFinite(end)
    ? Math.max(0, Math.floor((end - start) / 1000))
    : 0;
}

export function tournamentDuration(
  type: TournamentType | undefined,
  levels: { levelNo: number; durationSecs?: number | null }[],
  levelSecs: number,
  elapsed: number,
  timer?: { level: number; remaining: number },
): { label: string; value: string } {
  if (type === 'TIMED') {
    return {
      label: 'Time Remaining',
      value: levels.length
        ? formatDuration(
            levels.reduce(
              (total, level) =>
                total +
                (!timer || level.levelNo > timer.level ? (level.durationSecs ?? levelSecs) : 0),
              timer ? Math.max(0, timer.remaining) : 0,
            ),
          )
        : '—',
    };
  }
  return type
    ? { label: 'Elapsed', value: formatDuration(elapsed) }
    : { label: 'Time Remaining', value: '—' };
}
